
export default {
    name: 'Theme3NoContentAvailable',
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
    },
}
